import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, InputHours, Label } from "@activecollab/components";
import PropTypes from "prop-types";
import { getIsFeatureEnabled } from "~/store/selectors/selector.configOptions";
import { toDecimal, toHours } from "~/utils/utils";

export const TimeEstimate = ({ onChange, canEdit, estimate }) => {
  const { t } = useTranslation();
  const taskEstimatesEnabled = useSelector((state) => getIsFeatureEnabled(state, "task_estimates"));
  const [localEstimate, setLocalEstimate] = useState(estimate > 0 ? toHours(`${estimate}`) : "");

  const handleEstimateChange = useCallback((value) => {
    setLocalEstimate(value);
  }, []);

  if (!(taskEstimatesEnabled && canEdit)) {
    return null;
  }

  return (
    <div className="tw-flex tw-justify-between tw-items-center tw-mt-6">
      <Label size="small">{t("Time Estimate:")}</Label>
      <div className="tw-flex tw-items-center tw-gap-1">
        <InputHours
          value={localEstimate}
          className="tw-w-[90px]"
          onChange={handleEstimateChange}
          onBlurCapture={() => {
            onChange({ estimate: toDecimal(localEstimate) });
          }}
          data-testid="input-number"
        />
        <Caption1 color="tertiary">h</Caption1>
      </div>
    </div>
  );
};

TimeEstimate.propTypes = {
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
  estimate: PropTypes.string,
};
